<section class="newsletter-form" *ngIf=" action === 2 ">
	<div class="newsletter-form-header fondo-blue"></div>
	<section class="newsletter-form-form">
		<div class="newsletter-form-form-image">
			<img src="assets/images/logo-big.png" alt="Pawerful PetShop." loading="lazy">
		</div>
		<div class="newsletter-form-form-content">
			<h1>
				Tu baja a nuestro newsletter ha sido exitosa
				<p>
					<br>
					<small>
						Si deseas volver a recibir nuestros correos con información y promociones exclusivas para ti, coloca tu correo a continuación:
					</small>
				</p>
			</h1>
			<input type="text" placeholder="Ingresa tu correo electrónico" [(ngModel)]="correoElectronico">
		</div>
		<div class="newsletter-form-form-content-controls">
			<button (click)="fnVerificarCorreo()" class="newsletter-form-form-content-button fondo-purple">
				Suscribirme
			</button>
		</div>
	</section>
</section>
